<template>
  <div>
    <!-- approved profile in the admin archive: hidden from the catalog, the payment brings it back -->
    <div v-if="!user.active && user.archived_payable">
      <v-container class="cabinet-main">
        <AnnouncementsCard />
        <TelegramBotCard />
        <v-card class="pa-6">
          <p class="title">
            {{ $vuetify.lang.t("$vuetify.main.psychologistDashboard.welcomeMessage.hello") }}
            {{ user.name }}
            {{ user.middle_name }}!
          </p>
          <p class="mb-0">{{ $vuetify.lang.t("$vuetify.main.psychologistDashboard.stats.archivedPay") }}</p>
        </v-card>
        <div class="cabinet-main__pay">
          <a class="cabinet-main__pay-btn" :href="paySubscriptionUrl" target="_blank" rel="noopener">
            {{ $vuetify.lang.t("$vuetify.main.psychologistDashboard.stats.paySubscription") }}
          </a>
        </div>
      </v-container>
    </div>
    <!-- approved earlier and deactivated by the admin: not "under review" any more -->
    <div v-else-if="!user.active && user.approved">
      <v-container class="cabinet-main">
        <AnnouncementsCard />
        <TelegramBotCard />
        <v-card class="pa-6">
          <p class="title">
            {{ $vuetify.lang.t("$vuetify.main.psychologistDashboard.welcomeMessage.hello") }}
            {{ user.name }}
            {{ user.middle_name }}!
          </p>
          <p class="mb-0">{{ $vuetify.lang.t("$vuetify.main.psychologistDashboard.stats.deactivated") }}</p>
        </v-card>
      </v-container>
    </div>
    <div v-else-if="!this.user.active">
      <v-container>
        <AnnouncementsCard />
        <TelegramBotCard />
        <v-card class="pa-6">
          <p class="title">
            {{
              $vuetify.lang.t(
                "$vuetify.main.psychologistDashboard.welcomeMessage.hello"
              )
            }}
            {{ this.user.name }}
            {{ this.user.middle_name }}!
          </p>
          <p>
            {{
              $vuetify.lang.t(
                "$vuetify.main.psychologistDashboard.welcomeMessage.title"
              )
            }}
          </p>
          <p>
            {{
              $vuetify.lang.t(
                "$vuetify.main.psychologistDashboard.welcomeMessage.subtitle"
              )
            }}
          </p>
          <p>
            {{
              $vuetify.lang.t(
                "$vuetify.main.psychologistDashboard.welcomeMessage.description"
              )
            }}
          </p>
          <p>
            {{
              $vuetify.lang.t(
                "$vuetify.main.psychologistDashboard.welcomeMessage.informing"
              )
            }}
          </p>
          <p>
            {{
              $vuetify.lang.t(
                "$vuetify.main.psychologistDashboard.welcomeMessage.informing2"
              )
            }}
          </p>
        </v-card>
      </v-container>
    </div>
    <div v-else>
      <v-container class="cabinet-main">
        <AnnouncementsCard />
        <TelegramBotCard />
        <v-row>
          <v-col cols="12" md="7" lg="8" class="d-flex flex-column">
            <HostRoom />
            <!-- while the placement is paid the button is hidden, so a second subscription is not started by accident -->
            <div v-if="!user.subscription_active" class="cabinet-main__pay">
              <a class="cabinet-main__pay-btn" :href="paySubscriptionUrl" target="_blank" rel="noopener">
                {{ $vuetify.lang.t("$vuetify.main.psychologistDashboard.stats.paySubscription") }}
              </a>
            </div>
          </v-col>
          <v-col cols="12" md="5" lg="4">
            <ProfileStats />
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SUBSCRIPTION_PAY_URL } from "@/utils/subscriptionLock";
const HostRoom = () => import("../../VideoRoom/HostRoom");
const ProfileStats = () => import("./ProfileStats");
const AnnouncementsCard = () => import("./AnnouncementsCard");
const TelegramBotCard = () => import("./TelegramBotCard");
export default {
  name: "PsyhMainPage",
  components: { HostRoom, ProfileStats, AnnouncementsCard, TelegramBotCard },
  metaInfo() {
    return {
      title:
        "Платформа / " + this.$vuetify.lang.t("$vuetify.main.header.menu.main"),
    };
  },
  data() {
    return {
      paySubscriptionUrl: SUBSCRIPTION_PAY_URL,
    };
  },
  computed: {
    ...mapGetters({
      user: "user/getUser",
    }),
  },
  created() {
    this.$store.dispatch("user/getProfile", {});
  },
};
</script>

<style lang="scss">
.cabinet-card {
  padding: 30px 20px;
  background: #F4F4F4;
  border-radius: 10px;
}
.cabinet-card__title {
  margin: 0;
  font-size: 26px;
  font-weight: 500;
  line-height: 1.2;
  color: #575756;
}
</style>

<style lang="scss" scoped>
.cabinet-main {
  max-width: 1240px;
  padding-top: 40px;
}
.cabinet-main__pay {
  display: flex;
  justify-content: center;
  margin-top: 64px;
}
.cabinet-main__pay-btn {
  padding: 8px 16px;
  font-size: 18px;
  font-weight: 500;
  color: #3A3A3A !important;
  text-decoration: none;
  background: #DCE5EC;
  border: 1px solid #C9D6E0;
  border-radius: 3px;
}
.cabinet-main__pay-btn:hover {
  background: #CFDAE3;
}
@media (max-width: 960px) {
  .cabinet-main__pay {
    margin: 24px 0 8px;
  }
}
</style>
